import { render, staticRenderFns } from "./RelinkShopifyVariantDialog.vue?vue&type=template&id=5fe9aa2b"
import script from "./RelinkShopifyVariantDialog.vue?vue&type=script&lang=ts"
export * from "./RelinkShopifyVariantDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports